// AuthService.js
import axios from 'axios';

// Base configuration for Axios
export const API = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json'
  }
});

let cachedToken = null;

// Function to set the token from outside
export const setToken = (token) => {
  cachedToken = token;
};

// Function to get the cached token
export const getToken = () => {
  return cachedToken;
};

// Function to clear the token
export const clearToken = () => {
  cachedToken = null;
};

// Setup axios interceptor to automatically add token to all requests
API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('Added token to request:', config.url);
  } else {
    console.warn('No token available for request:', config.url);
  }
  return config;
}, (error) => {
  console.error('Request interceptor error:', error);
  return Promise.reject(error);
});

// Add response interceptor for error handling
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.error('Authentication error:', error.message);
      clearToken();
    }
    return Promise.reject(error);
  }
);

export default {
  API,
  setToken,
  getToken,
  clearToken
};